import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Metadata from '../components/Metadata';
import { fetchReviews } from '../lib/cms';

export default function KunderneSiger() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    async function loadReviews() {
      const data = await fetchReviews();
      setReviews(data);
    }
    loadReviews();
  }, []);

  return (
    <>
      <Metadata
        title="Kunderne siger - K. Pheiffer Construction"
        description="Læs hvad tidligere kunder siger om samarbejdet med K. Pheiffer Construction."
      />

      {/* Page Header */}
      <section className="bg-slate-950 text-white py-16 sm:py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(16,185,129,0.05),transparent_40%)]" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-400">
            Anbefalinger
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mt-2">
            Kunderne siger
          </h1>
          <p className="mt-4 text-slate-400 text-base sm:text-lg max-w-2xl mx-auto">
            Vores kunders tilfredshed er vores største succes. Her kan du læse de fulde anmeldelser fra boligejere, vi har hjulpet.
          </p>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="bg-white p-6 sm:p-8 rounded-xl border border-slate-100 shadow-sm flex flex-col justify-between"
              >
                <div>
                  {/* Star Rating */}
                  <div className="flex items-center gap-1 text-amber-400 mb-4">
                    {[...Array(review.rating || 5)].map((_, i) => (
                      <i key={i} className="fa-solid fa-star text-sm" />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="text-slate-600 text-sm sm:text-base leading-relaxed italic">
                    "{review.review}"
                  </p>
                </div>

                {/* Reviewer Info */}
                <div className="mt-6 pt-4 border-t border-slate-100 flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-700 font-bold text-sm border border-slate-200">
                    {review.name ? review.name.charAt(0) : 'K'}
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900 text-sm sm:text-base">
                      {review.name}
                    </h4>
                    <p className="text-xs text-slate-500 flex items-center gap-1">
                      <i className="fa-regular fa-location-dot text-emerald-600" />
                      {review.location}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="mt-16 bg-slate-50 rounded-2xl p-8 sm:p-12 text-center border border-slate-100 max-w-3xl mx-auto">
            <h3 className="text-xl sm:text-2xl font-bold text-slate-900">
              Har vi hjulpet dig med et projekt?
            </h3>
            <p className="mt-2 text-slate-500 text-sm sm:text-base">
              Vi sætter stor pris på din feedback. Hvis du har samarbejdet med os, hører vi meget gerne om din oplevelse.
            </p>
            <div className="mt-6">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center rounded bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 text-sm font-semibold tracking-wide transition-colors"
              >
                Kontakt os og giv din feedback
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
